import * as types from './types'

export const addError = (error: Error) => ({
    type: types.ADD_ERROR,
    error,
})

export const removeError = (error: Error) => ({
    type: types.REMOVE_ERROR,
    error,
})
